import { useState } from "react";
import { formatTimeAgo } from "../../utilities/common";
import ReactPaginate from "react-paginate";

const AllGamesTable = ({ data, columns }: any) => {
  if (data.length === 0) return <></>;
  const [currentPage, setCurrentPage] = useState(1);
  const [gamesPerPage] = useState(5);

  const indexOfLastPost = currentPage * gamesPerPage;
  const indexOfFirstPost = indexOfLastPost - gamesPerPage;
  const currentGames = data.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = ({ selected }: any) => {
    setCurrentPage(selected + 1);
  };

  return (
    <div className="overflow-x-auto sm:w-auto sm:mx-8 mt-8 bg-white w-[90vw] mx-auto dark:bg-neutral-800 rounded-xl mb-24">
      <table className="table block">
        {/* head */}
        <thead>
          <tr className="dark:border-b-neutral-700">
            <th></th>
            {columns.map((e: any, index: any) => {
              return (
                <th key={index} className="dark:text-neutral-100">
                  {e}
                </th>
              );
            })}
          </tr>
        </thead>
        {data ? (
          <tbody>
            {currentGames.map((e: any, index: number) => {
              return (
                <tr
                  className="hover:bg-neutral-100 dark:hover:bg-neutral-900 border-b-neutral-200 dark:border-b-neutral-700"
                  key={e.id}
                >
                  <th>
                    {index + 1 + gamesPerPage * currentPage - gamesPerPage}
                  </th>
                  {e.player_one ? (
                    <td>
                      {e.player_one?.first_name + " " + e.player_one?.last_name}
                    </td>
                  ) : (
                    <td className="text-xs text-danger">player removed</td>
                  )}
                  {e.player_two ? (
                    <td>
                      {e.player_two?.first_name + " " + e.player_two?.last_name}
                    </td>
                  ) : (
                    <td>нема</td>
                  )}
                  <td>{e.game_length} час(а)</td>
                  <td title={e.created_at}>{formatTimeAgo(e.created_at)}</td>
                </tr>
              );
            })}
          </tbody>
        ) : (
          <div className="loading">loading</div>
        )}
      </table>
      <div className="border-t-neutral-700 border-t">
        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(data.length / gamesPerPage)}
          previousLabel={"PREV"}
          nextLabel={"NEXT"}
          containerClassName={
            "pagination flex gap-2 justify-center text-sm py-4"
          }
          pageLinkClassName={
            "page-number select-none p-2 px-3 bg-neutral-200 dark:bg-neutral-700 rounded-lg"
          }
          previousLinkClassName={
            "page-number text-xs bg-neutral-200 dark:bg-neutral-700 px-3 py-2 rounded-lg select-none"
          }
          nextLinkClassName={
            "page-number text-xs bg-neutral-200 dark:bg-neutral-700 px-3 py-2 rounded-lg select-none"
          }
          activeLinkClassName={
            "active bg-neutral-400 dark:bg-neutral-900 font-semibold"
          }
        />
      </div>
    </div>
  );
};

export default AllGamesTable;
